import { render, staticRenderFns } from "./StepsComponent.vue?vue&type=template&id=9bcbfee0&scoped=true"
import script from "./StepsComponent.vue?vue&type=script&lang=js"
export * from "./StepsComponent.vue?vue&type=script&lang=js"
import style0 from "./StepsComponent.vue?vue&type=style&index=0&id=9bcbfee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcbfee0",
  null
  
)

export default component.exports